<div class="container-fluid filter-content filter-container">
  <div class="border-bottom">
    <div class="col-9 pl-3">
      <h4 mat-dialog-title>Columns</h4>
    </div>
  </div>

  <mat-dialog-content class="mat-typography">
    <div class="mt-3 drag-list" cdkDropList (cdkDropListDropped)="drop($event)"  #dragListContainer [cdkDropListAutoScrollDisabled]="false" [cdkDropListAutoScrollStep]="2"        >
      <div class="row py-2 drag-list-box" *ngFor="let col of master_columns" cdkDrag [cdkDragData]="col" (cdkDragMoved)="onDragMoved($event)"
      (cdkDragStarted)="onDragStarted($event)">
        <div class="col-xl-2">
          <mat-checkbox
            *ngIf="!col?.allowtohide"
            class="gridSelectionChkbx"
            [disabled]="!col?.allowtohide"
            [checked]="true"
          >
          </mat-checkbox>

          <mat-checkbox
            *ngIf="col?.allowtohide"
            class="gridSelectionChkbx"
            [disabled]="!col?.allowtohide"
            [(ngModel)]="col.isVisible"
            (click)="$event.stopPropagation()"
            (change)="$event ? rowToogle($event, col) : null"
          >
          </mat-checkbox>
        </div>
        <div class="col-xl-8 col-xs-8">
          <p>{{ col.displayName }}</p>
        </div>
        <div class="cdk-drag-handle col-xl-2 col-xs-2" cdkDragHandle>
          <mat-icon>drag_handle</mat-icon> <!-- MatIcon for drag handle -->
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <div class="d-flex justify-content-center align-items-center">
      <button mat-flat-button class="btn-outlined" (click)="clear()">
        Cancel
      </button>
      <button mat-flat-button class="btn-main" (click)="submit()">
        Update
      </button>
    </div>
  </mat-dialog-actions>
</div>
